export type CheckoutPaymentMethod = 'visa' | 'cash' | 'apple_pay' | 'google_pay';

const LABELS: Record<CheckoutPaymentMethod | 'points' | 'wallet', string> = {
  visa: 'Visa / card',
  cash: 'Cash',
  apple_pay: 'Apple Pay',
  google_pay: 'Google Pay',
  points: 'Points',
  wallet: 'Wallet',
};

export function formatPaymentMethodLabel(method?: string | null): string {
  const key = String(method || '').toLowerCase().trim() as keyof typeof LABELS;
  return LABELS[key] || (method ? method.charAt(0).toUpperCase() + method.slice(1) : '—');
}
